(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/scPublish/modal-confirm-publish', '<div class="admin-modal_main">\n' + '  <i class="admin-modal_warning fa fa-exclamation-triangle"></i>\n' + '  <h1 class="admin-modal_title">Are you sure?</h1>\n' + '  <p class="admin-modal_p">You are about to publish your campaign</p>\n' + '  <a href class="admin-button__primary" ng-click="publishCampaign()">Publish</a>\n' + '  <a href class="admin-button__primary gray" ng-click="$root.flowModal.close(false)">Cancel</a>\n' + '</div>\n' + '');
}]);
})();